import { inject } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { EventService } from '@jfw/angular/ecommerce/core';
import { DealerEventService } from '@jfw/angular/ecommerce/shared';

export const verifyDealerUserGuard = async (
  routerStateSnapshot: RouterStateSnapshot,
): Promise<boolean> => {
  console.log(
    '%c* VERIFY DEALER USER GUARD START *',
    'background-color: Moccasin;color:black',
  );

  const router = inject(Router);
  const dealerEventService = inject(DealerEventService);
  const eventService = inject(EventService);

  const routeEventId =
    routerStateSnapshot.root.children[0].children[0].params.eventId;
  // console.log("routeEventId", routeEventId);

  // Check if user has a dealerUserEvent for this eventId.
  try {
    // the api should return an error if the event is not found.  If the dealerUserEvent is returned, then the user has access to it.
    // The equality check is probably not necessary, but it's a good sanity check.
    const dealerUserEvent =
      await dealerEventService.getDealerUserEventById(routeEventId);
    const hasEvent = dealerUserEvent.eventId === routeEventId;

    if (!hasEvent) {
      console.warn(
        '%c* Event not found in DealerUserEvents.  Redirecting to home screen. *',
        'background-color: Moccasin;color:black',
      );

      router.navigate(['dashboard']);
      return false;
    }

    console.log(
      `%c* Event found in DealerUserEvents. *`,
      'background-color: Moccasin;color:black',
    );

    // Check if the event is accepted.
    const { acceptedDate } = dealerUserEvent;
    const isAccepted = acceptedDate !== undefined && acceptedDate !== 0;

    if (!isAccepted) {
      console.log(
        '%c * Event is not accepted.  Access GRANTED. *',
        'background-color: Moccasin;color:black',
      );

      await eventService.setSelectedEvent(
        routeEventId,
        'verifyDealerUserGuard',
      );

      return true;
    }

    console.log(
      '%c* Event is accepted.  Access DENIED.  Re-routing to event-details *',
      'background-color: Moccasin;color:black',
    );

    router.navigate(['event-details', routeEventId]);
    return false;
  } catch (error: any) {
    if (error?.status === 404) {
      console.warn(
        `Event not found in DealerUserEvents.  Redirecting to home.`,
      );
    } else {
      console.error(
        'Error fetching DealerUserEvents. Redirecting to home.',
        error,
      );
    }
    router.navigate(['dashboard']);
    return false;
  }
};
